/* Botanica Bold — vanilla storefront JS */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    const fmt = (document.body.dataset.moneyFormat || '${{amount}}').replace('{{amount}}', (cents / 100).toFixed(2));
    return fmt;
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2600);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(drawer, overlay) {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer, overlay) {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }
  const cartDrawer = $('#CartDrawer'), cartOverlay = $('#CartOverlay');
  const searchDrawer = $('#SearchDrawer'), searchOverlay = $('#SearchOverlay');
  const mobileNav = $('#MobileNav');

  $$('[data-open-cart]').forEach(b => b.addEventListener('click', () => openDrawer(cartDrawer, cartOverlay)));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', () => closeDrawer(cartDrawer, cartOverlay)));
  if (cartOverlay) cartOverlay.addEventListener('click', () => closeDrawer(cartDrawer, cartOverlay));
  $$('[data-open-search]').forEach(b => b.addEventListener('click', () => {
    openDrawer(searchDrawer, searchOverlay);
    const i = $('#SearchDrawer input[type="search"]'); if (i) setTimeout(() => i.focus(), 250);
  }));
  $$('[data-close-search]').forEach(b => b.addEventListener('click', () => closeDrawer(searchDrawer, searchOverlay)));
  if (searchOverlay) searchOverlay.addEventListener('click', () => closeDrawer(searchDrawer, searchOverlay));
  const burger = $('#Burger'), mobileOverlay = $('#MobileOverlay');
  if (burger && mobileNav) {
    burger.addEventListener('click', () => { mobileNav.classList.add('open'); if (mobileOverlay) mobileOverlay.hidden = false; document.body.style.overflow = 'hidden'; });
    const closeMobile = () => { mobileNav.classList.remove('open'); if (mobileOverlay) mobileOverlay.hidden = true; document.body.style.overflow = ''; };
    const mc = $('#MobileClose'); if (mc) mc.addEventListener('click', closeMobile);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);
  }
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    [ [cartDrawer, cartOverlay], [searchDrawer, searchOverlay] ].forEach(([d, o]) => { if (d && d.classList.contains('open')) closeDrawer(d, o); });
    if (mobileNav && mobileNav.classList.contains('open')) mobileNav.classList.remove('open');
    if (mobileOverlay) mobileOverlay.hidden = true;
    document.body.style.overflow = '';
  });

  /* ---------- Free-shipping progress ---------- */
  function renderShipProgress(subtotalCents) {
    const wrap = $('[data-ship-progress]');
    if (!wrap) return;
    const threshold = parseInt(document.body.dataset.freeShippingThreshold || '70', 10) * 100;
    const msg = $('[data-ship-msg]', wrap), fill = $('[data-ship-fill]', wrap);
    const pct = threshold > 0 ? Math.min(100, Math.round(subtotalCents / threshold * 100)) : 100;
    fill.style.width = pct + '%';
    if (subtotalCents >= threshold || threshold === 0) {
      wrap.classList.add('ship-progress--done');
      msg.innerHTML = '<strong>✓ ' + (document.body.dataset.freeShipMsg || 'You have unlocked FREE standard shipping on eligible items — final shipping is calculated at checkout.') + '</strong>';
    } else {
      wrap.classList.remove('ship-progress--done');
      msg.innerHTML = 'You\'re <strong>' + money(threshold - subtotalCents) + '</strong> away from FREE shipping';
    }
  }
  document.body.dataset.freeShipMsg = document.body.dataset.freeShipMsg || '';

  /* ---------- Cart rendering ---------- */
  function lineHTML(item) {
    const img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '';
    return '<div class="cart-line" data-line-key="' + item.key + '">' +
      '<a class="cart-line__media" href="' + item.url + '">' + img + '</a>' +
      '<div class="cart-line__info">' +
      '<p class="cart-line__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
      (item.variant_title ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '') +
      '<div class="cart-line__row"><div class="qty" data-qty data-key="' + item.key + '">' +
      '<button type="button" data-qty-dec aria-label="Decrease">−</button>' +
      '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
      '<button type="button" data-qty-inc aria-label="Increase">+</button></div>' +
      '<p class="cart-line__price">' + money(item.final_line_price) + '</p></div>' +
      '<button type="button" class="cart-line__remove" data-line-remove="' + item.key + '">Remove</button>' +
      '</div></div>';
  }
  async function refreshCart(openAfter) {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const itemsWrap = $('[data-cart-items]');
      if (itemsWrap) itemsWrap.innerHTML = cart.items.map(lineHTML).join('');
      $$('[data-cart-count]').forEach(el => el.textContent = '(' + cart.item_count + ')');
      $$('.cart-count-bubble').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      const sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      const empty = $('[data-cart-empty]'), foot = $('[data-cart-foot]');
      if (empty) empty.hidden = cart.item_count > 0;
      if (foot) foot.hidden = cart.item_count === 0;
      renderShipProgress(cart.total_price);
      if (openAfter) openDrawer(cartDrawer, cartOverlay);
    } catch (e) { /* fail silently */ }
  }
  async function changeLine(key, qty) {
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      refreshCart(false);
    } catch (e) { toast('Something went wrong — try again.'); }
  }
  document.addEventListener('click', async e => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      qa.disabled = true;
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: qa.dataset.quickAdd, quantity: 1 }) });
        await refreshCart(true);
        toast('Added to cart ✓');
      } catch (err) { toast('Couldn\'t add that — try again.'); }
      qa.disabled = false;
      return;
    }
    const inc = e.target.closest('[data-qty-inc]'), dec = e.target.closest('[data-qty-dec]');
    if (inc || dec) {
      const wrap = (inc || dec).closest('[data-qty]');
      const input = $('[data-qty-input]', wrap);
      const key = wrap.dataset.key || (wrap.closest('[data-line-key]') || {}).dataset?.lineKey;
      let q = parseInt(input.value || '1', 10) + (inc ? 1 : -1);
      if (q < 0) q = 0;
      if (key) changeLine(key, q); else { input.value = q; }
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(rm.dataset.lineRemove, 0); return; }
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      const form = addBtn.closest('form');
      if (!form) return;
      e.preventDefault();
      addBtn.disabled = true;
      const fd = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'error');
        await refreshCart(true);
        toast('Added to cart ✓');
      } catch (err) { toast(err.message || 'Couldn\'t add that — try again.'); }
      addBtn.disabled = false;
    }
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const wrap = input.closest('[data-qty]');
    const key = wrap.dataset.key || (wrap.closest('[data-line-key]') || {}).dataset?.lineKey;
    let q = parseInt(input.value || '0', 10);
    if (isNaN(q) || q < 0) q = 0;
    if (key) changeLine(key, q);
  });

  /* ---------- Product gallery thumbs ---------- */
  document.addEventListener('click', e => {
    const th = e.target.closest('[data-thumb]');
    if (!th) return;
    const main = $('#ProductMainImg');
    if (main && th.dataset.full) {
      main.src = th.dataset.full;
      main.srcset = th.dataset.srcset || '';
      $$('[data-thumb]').forEach(t => t.classList.remove('product__thumb--active'));
      th.classList.add('product__thumb--active');
    }
  });

  /* ---------- Carousel buttons ---------- */
  $$('[data-carousel-prev], [data-carousel-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      const track = document.getElementById(btn.dataset.carouselPrev || btn.dataset.carouselNext);
      if (!track) return;
      const card = track.querySelector(':scope > *');
      const step = card ? card.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: btn.hasAttribute('data-carousel-next') ? step : -step, behavior: 'smooth' });
    });
  });

  /* ---------- Collection sort ---------- */
  const sortSel = $('#SortSelect');
  if (sortSel) sortSel.addEventListener('change', () => { window.location.href = sortSel.value; });

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  $$('.marquee__track').forEach(track => {
    if (track.dataset.duped) return;
    track.dataset.duped = '1';
    track.innerHTML += track.innerHTML;
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(el => io.observe(el));
  } else {
    $$('.reveal').forEach(el => el.classList.add('in'));
  }

  /* ---------- Newsletter (native form fallback is fine; enhance) ---------- */
  $$('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', () => {
      const ok = $('[data-newsletter-success]', form.closest('.newsletter') || document);
      setTimeout(() => { if (ok) ok.hidden = false; }, 600);
    });
  });

  /* ---------- Init ---------- */
  fetch('/cart.js').then(r => r.json()).then(c => renderShipProgress(c.total_price)).catch(() => {});
})();
